import type { BlockContent } from '@/blocks/domain/types/BlockContent';
import { isBlankProseHtml } from '@/document-render/application/isBlankProseHtml';

/**
 * True when the content is a prose kind (Terms, Scope of Work, Comments, Custom text) whose body has
 * no visible text. The PDF Templates API refuses to publish such a snapshot (`BlockJsonSnapshotRules`),
 * so callers skip or block the publish instead of sending a request that can only fail (LLAMS-686).
 * A sectioned Custom block is not prose here: its content lives in fields.
 */
export function isBlankProseContent(content: BlockContent): boolean {
  return content.kind !== 'custom' && 'bodyHtml' in content && isBlankProseHtml(content.bodyHtml);
}
